import { ReactNode } from "react";
import { Avatar as AvatarBase } from "shared/components/atoms/Avatar";
import { BackgroundImage } from "shared/components/atoms/BackgroundImage";
import { CSSProp } from "styled-components";
import { css, styled } from "twin.macro";

const Background = styled(BackgroundImage)<{ bottomGradient?: boolean }>`
  &:before {
    display: block;
    background: linear-gradient(transparent, #000 70%);
  }

  ${({ bottomGradient = false }) =>
    bottomGradient &&
    `
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 20%;
      position: absolute;
      bottom: 0;
      background: linear-gradient(transparent, #000);
    }
  `}
`;

const Avatar = styled(AvatarBase)<{ index: number }>`
  border: 2px solid #fff;
  border-radius: 100%;
  position: absolute;

  ${({ index }) => `
  &:nth-child(${index}) {
    right: ${16 * index}px;
  }
  `}
`;

interface Props {
  src: string;
  title: string;
  catchCopy?: string;
  description?: string;
  bottomGradient?: boolean;
  titleFamily?: "ヒラギノ明朝 ProN" | "ヒラギノ角ゴシック";
  avatars?: string[];
  renderItem?: ReactNode;
  classes?: {
    title: CSSProp;
  };
}

/** onErrorで画像がないときのエラーを検出できない + 画像の最適化が為されないのでNextImageでposition: absoluteを使った実装に変えたい... */
export const BackgroundHeader = ({
  src,
  title,
  catchCopy,
  description,
  bottomGradient,
  titleFamily,
  avatars,
  renderItem,
  classes,
}: Props) => {
  return (
    <Background
      src={src}
      height={300}
      bottomGradient={bottomGradient}
      tw="mb-7"
    >
      <div tw="w-full min-h-[60%] absolute bottom-0 pt-4 px-4 pb-6">
        <div tw="flex items-center justify-between">
          <h1
            tw="font-semibold text-base leading-4 tracking-[.47px] text-white"
            css={[css({ fontFamily: titleFamily }), classes?.title]}
          >
            {title}
            <div tw="font-semibold text-theme text-[8px] tracking-[.23px] mt-2">
              {catchCopy}
            </div>
          </h1>
          {avatars.length > 0 && (
            <div tw="flex items-center mb-4">
              {avatars.map((avatar, index) => (
                <Avatar
                  key={index}
                  src={avatar}
                  size={24}
                  index={index + 1}
                  blur={1.1}
                />
              ))}
            </div>
          )}
        </div>
        {(description || renderItem) && (
          <div tw="mt-6">
            {description && (
              <p tw="font-light text-2xs leading-[17px] text-[#fff]">
                {description}
              </p>
            )}
            {!description && renderItem && renderItem}
          </div>
        )}
      </div>
    </Background>
  );
};
